import { render, staticRenderFns } from "./linkUrl.vue?vue&type=template&id=08882fa4&scoped=true&"
import script from "./linkUrl.vue?vue&type=script&lang=js&"
export * from "./linkUrl.vue?vue&type=script&lang=js&"
import style0 from "./linkUrl.vue?vue&type=style&index=0&id=08882fa4&scoped=true&lang=less&"
import style1 from "./linkUrl.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08882fa4",
  null
  
)

export default component.exports